import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const links = [
  { label: 'Research', to: '/research' },
  { label: 'Integrations', to: '/integrations' },
  { label: 'About', to: '/about' },
  { label: 'Contact', to: '/contact' },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => setMenuOpen(false), [pathname]);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-dark/95 backdrop-blur-md border-b border-gray-800/60 shadow-xl' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <img src="/favicon.ico" alt="InjectAI Labs" className="w-9 h-9" />
          <span className="font-bold text-lg tracking-tight">
            InjectAI <span className="text-primary">Labs</span>
          </span>
        </Link>

        {/* Desktop */}
        <div className="hidden md:flex items-center gap-8">
          {links.map(l => (
            <Link
              key={l.label}
              to={l.to}
              className={`text-sm font-medium transition-colors ${pathname === l.to ? 'text-white' : 'text-gray-400 hover:text-white'}`}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/contact"
            className="px-5 py-2 bg-primary hover:bg-blue-600 rounded-lg text-sm font-semibold transition-all"
          >
            Get Access
          </Link>
        </div>

        {/* Mobile toggle */}
        <button className="md:hidden text-gray-400 hover:text-white" onClick={() => setMenuOpen(!menuOpen)}>
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {menuOpen
              ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />}
          </svg>
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-dark-light border-t border-gray-800 px-6 py-4 flex flex-col gap-4">
          {links.map(l => (
            <Link
              key={l.label}
              to={l.to}
              className={`font-medium transition-colors ${pathname === l.to ? 'text-white' : 'text-gray-300 hover:text-white'}`}
            >
              {l.label}
            </Link>
          ))}
          <Link to="/contact" className="px-5 py-2 bg-primary rounded-lg text-sm font-semibold text-center">
            Get Access
          </Link>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
